import type { ComponentType } from "react";
import type { EcranProps } from "../ecrans/types";

import { LectureAutomatique } from "../ecrans/dossier/LectureAutomatique";
import { TableauDeBord } from "../ecrans/synthese/TableauDeBord";
import { Reporting } from "../ecrans/synthese/Reporting";
import { Diagnostic } from "../ecrans/synthese/Diagnostic";
import { Estimations } from "../ecrans/synthese/Estimations";

import {
  ConsultationClient,
  DossierTraitement,
  Justificatifs,
  Transmissions,
} from "../ecrans/dossier/Dossier";
import { AuditDocumentaire } from "../ecrans/dossier/AuditDocumentaire";

import { JournalEcritures, BalanceGenerale } from "../ecrans/comptable/EtatsComptables";
import { Bilan, CompteResultat, GrandLivre } from "../ecrans/comptable/GrandLivreEtSynthese";

import { FacturationTva } from "../ecrans/fiscal/FacturationTva";
import { GrilleDeclarative, SuiviFiscal } from "../ecrans/fiscal/SuiviFiscal";
import { AnalyseReleve } from "../ecrans/fiscal/AnalyseReleve";

import { Paie, Personnel } from "../ecrans/social/PaieEtPersonnel";
import { Interventions, Requetes, SuiviDirect } from "../ecrans/relation/Relation";

/**
 * Table des 22 écrans. Chaque clé de `navigation.ts` DOIT trouver son composant
 * ici : le typage l'impose, et un écran déclaré sans composant échoue au build,
 * pas au clic.
 */
export const ECRANS: Record<string, ComponentType<EcranProps>> = {
  // Synthèse
  "tableau-de-bord": TableauDeBord,
  reporting: Reporting,
  diagnostic: Diagnostic,
  estimations: Estimations,

  // Dossier
  "dossier-traitement": DossierTraitement,
  "consultation-client": ConsultationClient,
  justificatifs: Justificatifs,
  "audit-documentaire": AuditDocumentaire,
  "lecture-automatique": LectureAutomatique,
  "suivi-direct": SuiviDirect,

  // Base comptable
  "journal-ecritures": JournalEcritures,
  balance: BalanceGenerale,
  "grand-livre": GrandLivre,
  "compte-resultat": CompteResultat,
  bilan: Bilan,

  // Fiscal
  "facturation-tva": FacturationTva,
  "suivi-fiscal": SuiviFiscal,
  obligations: GrilleDeclarative,
  "analyse-releve": AnalyseReleve,

  // Social
  paie: Paie,
  personnel: Personnel,

  // Relation
  interventions: Interventions,
  requetes: Requetes,

  // Hors navigation : accessible depuis la fiche
  transmissions: Transmissions,
};
